import React, { useEffect, useState } from "react";

import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import OwlCarousel from "react-owl-carousel";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import apiClient from "../services/apiClient";
import webTicketApiClient from "../services/webTicketApiClient";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "../assets/css/style.css";

// Keeps your existing Carousel items
const carouselItems = [
  { title: "Fashion", imagePath: require("../assets/images/header_icons/menu-1.png") },
  { title: "Electronics", imagePath: require("../assets/images/header_icons/menu-2.jpg") },
  { title: "Appliances", imagePath: require("../assets/images/header_icons/menu-3.jpg") },
  { title: "Repair", imagePath: require("../assets/images/header_icons/menu-4.jpg") },
  { title: "Carpenter", imagePath: require("../assets/images/header_icons/menu-5.jpg") },
  { title: "Grooming", imagePath: require("../assets/images/header_icons/menu-6.jpg") },
  { title: "Electronics", imagePath: require("../assets/images/header_icons/menu-7.png") },
  { title: "Travel", imagePath: require("../assets/images/header_icons/menu-8.jpg") },
  { title: "Vegetables", imagePath: require("../assets/images/header_icons/menu-9.jpg") },
  { title: "Grocery", imagePath: require("../assets/images/header_icons/menu-10.jpg") },
  { title: "Vehicle care", imagePath: require("../assets/images/header_icons/menu-11.jpg") },
  { title: "Self jobs", imagePath: require("../assets/images/header_icons/menu-12.jpg") },
  { title: "Food", imagePath: require("../assets/images/header_icons/menu-13.jpg") },
  { title: "Rental services", imagePath: require("../assets/images/header_icons/menu-14.jpg") },
];

const scrollMenuOwlOptions = {
  items: 10, loop: true, margin: 10, nav: true, dots: false,
  responsive: { 0: { items: 3 }, 576: { items: 4 }, 768: { items: 6 }, 992: { items: 8 }, 1200: { items: 10 } },
};

const gradientBg = {
  position: "relative",
  background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)",
  minHeight: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center", padding: "4rem 0", margin: 0,
  overflow: "hidden",
  fontFamily: "var(--font-family, 'Outfit', sans-serif)",
};

const cardStyle = {
  position: "relative",
  zIndex: 2,
  border: "1px solid rgba(255, 255, 255, 0.7)",
  background: "rgba(255, 255, 255, 0.88)",
  backdropFilter: "blur(20px)",
  WebkitBackdropFilter: "blur(20px)",
  boxShadow: "0 24px 64px -16px rgba(15, 23, 42, 0.12), 0 0 0 1px rgba(40, 115, 240, 0.05)",
  padding: "3rem 2.25rem",
  borderRadius: "24px",
  width: "100%",
  maxWidth: 520,
  margin: "0 1rem",
  textAlign: "center",
};

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mobile = searchParams.get("mobileid");
  const returnTo = searchParams.get("returnTo");
  const location = useLocation();
  const fromAddBusiness = location.state?.fromAddBusiness;
  const [loginError, setLoginError] = useState("");

  const handleCallbackResponse = async (response) => {
    const userObject = jwtDecode(response.credential);

    if (returnTo && returnTo.startsWith("/trustUserTicketStatus")) {
      try {
        const webSession = await webTicketApiClient.post("/api/v2/web/auth/google", {
          credential: response.credential,
        });
        sessionStorage.setItem("trust_web_csrf", webSession.data.csrfToken);
        localStorage.setItem("user", JSON.stringify({
          email: webSession.data.email,
          exp: Math.floor(webSession.data.expiresAt / 1000),
        }));
        setLoginError("");
        navigate(returnTo, { replace: true });
      } catch (error) {
        console.error("[Login] Failed to create a secure website session:", error);
        setLoginError(error.response?.data?.message || "Unable to securely sign in. Please try again.");
      }
      return;
    }

    localStorage.setItem("user", JSON.stringify(userObject));

    try {
      const webSession = await webTicketApiClient.post("/api/v2/web/auth/google", {
        credential: response.credential,
      });
      sessionStorage.setItem("trust_web_csrf", webSession.data.csrfToken);
    } catch (error) {
      sessionStorage.removeItem("trust_web_csrf");
      console.info("[Login] Secure ticket session was not created for this account.");
    }

    try {
      await apiClient.post("/v1/trust/web-login-audit", {
        emailId: userObject.email,
      });
    } catch (error) {
      console.error("[Login] Failed to record web login audit:", error);
    }

    // MODIFIED: Conditional navigation based on mobile number presence
    if (mobile) { // If mobile is present in the session
      navigate("/my-contacts", { state: { mobile, email: userObject.email } });
    } else { // If only email is available
      navigate("/utility-dashboard", { state: { email: userObject.email } });
    }
  };

  useEffect(() => {
    if (!fromAddBusiness) {
      /* global google */
      const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ||
        "877160301195-mv6r6ti7fdcqi96elc5ggq3h5kive1m8.apps.googleusercontent.com";

      try {
        console.log("[Login] window.location.origin:", window.location?.origin, "GOOGLE_CLIENT_ID:", GOOGLE_CLIENT_ID);
      } catch (err) {
        // ignore
      }

      if (window.google) {
        google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleCallbackResponse,
        });

        google.accounts.id.renderButton(
          document.getElementById("googleSignInDiv"),
          { theme: "outline", size: "large", shape: "pill", width: "320" }
        );
      }
    }
  }, [fromAddBusiness, mobile]); // Added mobile to dependencies

  return (
    <>
      <Header />
      <div className="scrollmenu">
        <OwlCarousel className="owl-carousel" id="scroll_menu" {...scrollMenuOwlOptions}>
          {carouselItems.map((item, index) => (
            <div key={index} className="item">
              <a className="nav-link" href="#">
                <img className="header_icons" src={item.imagePath} alt={item.title} />
                {item.title}
              </a>
            </div>
          ))}
        </OwlCarousel>
      </div>
      <section style={gradientBg}>
        {/* Glowing background shapes matching the website design */}
        <div style={{
          position: "absolute",
          top: "10%",
          left: "15%",
          width: "350px",
          height: "350px",
          background: "radial-gradient(circle, rgba(40,115,240,0.15) 0%, rgba(40,115,240,0) 70%)",
          borderRadius: "50%",
          filter: "blur(50px)",
          pointerEvents: "none",
          zIndex: 1,
        }} />
        <div style={{
          position: "absolute",
          bottom: "10%",
          right: "15%",
          width: "400px",
          height: "400px",
          background: "radial-gradient(circle, rgba(234,60,83,0.1) 0%, rgba(234,60,83,0) 70%)",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          zIndex: 1,
        }} />

        <div style={cardStyle} className="premium-card">
          <style>{`
            .premium-card {
              transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            }
            .step-item {
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }
            .step-item:hover {
              transform: translateX(4px);
              background: #ffffff !important;
              box-shadow: 0 8px 16px rgba(40, 115, 240, 0.05), 0 0 0 1px rgba(40, 115, 240, 0.1) !important;
            }
            .youtube-link {
              color: #ea3c53;
              font-weight: 600;
              text-decoration: none;
              transition: all 0.2s ease;
            }
            .youtube-link:hover {
              color: #c12b3f;
              text-decoration: underline;
            }
            .playstore-link {
              color: #2873f0;
              font-weight: 600;
              text-decoration: none;
              transition: all 0.2s ease;
            }
            .playstore-link:hover {
              color: #1b5bc7;
              text-decoration: underline;
            }
            .business-login-heading {
              font-size: 1.85rem;
              white-space: nowrap;
            }
            .google-btn-container {
              display: flex;
              justify-content: center;
              margin: 2rem 0;
              background: linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%);
              padding: 1.5rem;
              border-radius: 16px;
              box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 4px 16px rgba(0,0,0,0.2);
              border: 1px solid rgba(100,116,139,0.3);
            }
            .qr-container {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              gap: 1.5rem;
              margin-bottom: 2.5rem;
              background: #f8fafc;
              padding: 1.25rem;
              border-radius: 16px;
              border: 1px solid #e2e8f0;
            }
            @media (max-width: 576px) {
              .qr-container {
                flex-direction: column;
                text-align: center;
                gap: 1rem;
              }
              .qr-container div {
                align-items: center !important;
              }
              .business-login-heading {
                font-size: 2.1rem;
                white-space: normal;
              }
            }
          `}</style>

          {fromAddBusiness ? (
            <>
              <h3 className="business-login-heading" style={{
                color: "#1e293b",
                marginBottom: "12px",
                fontWeight: "800",
                background: "linear-gradient(135deg, #1e293b 0%, #2873f0 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                letterSpacing: "-0.5px"
              }}>
                Add your Business in TrustApp
              </h3>
              <p style={{
                color: "#475569",
                fontSize: "0.95rem",
                marginBottom: "2rem",
                fontWeight: "500",
                lineHeight: "1.5"
              }}>
                Get more local customers and powerful business utility tools.
              </p>
            </>
          ) : (
            <>
              <h3 style={{
                fontSize: "2.1rem",
                color: "#1e293b",
                marginBottom: "12px",
                fontWeight: "800",
                background: "linear-gradient(135deg, #1e293b 0%, #2873f0 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                letterSpacing: "-0.5px"
              }}>
                Trust App Login
              </h3>
              <p style={{
                color: "#475569",
                fontSize: "0.95rem",
                marginBottom: "2rem",
                fontWeight: "500"
              }}>
                One-tap secure access to your Trust app account.
              </p>
            </>
          )}

          {fromAddBusiness ? (
            <div style={{
              background: "rgba(40, 115, 240, 0.05)",
              border: "1px solid rgba(40, 115, 240, 0.12)",
              padding: "0.85rem 1.25rem",
              borderRadius: "14px",
              marginBottom: "2rem"
            }}>
              <p style={{ fontWeight: "600", color: "#1e3a8a", fontSize: "0.95rem", margin: 0, lineHeight: "1.4" }}>
                Download app and create a service provider account in app as guided below
              </p>
            </div>
          ) : (
            <>
              <div className="google-btn-container">
                <div id="googleSignInDiv"></div>
              </div>
              {loginError && (
                <p role="alert" style={{ color: "#b91c1c", fontWeight: "600", margin: "-1rem 0 1rem" }}>
                  {loginError}
                </p>
              )}
            </>
          )}

          <div style={{ borderTop: "1px solid rgba(40, 115, 240, 0.12)", paddingTop: "2rem", marginTop: "2.25rem" }}>
            <div style={{ textAlign: "center" }}>
               <p style={{ marginBottom: "1rem", fontWeight: "700", color: "#2873f0", fontSize: "1.05rem", textTransform: "uppercase", letterSpacing: "0.5px" }}>Download Trust App</p>
               
               <div className="qr-container">
                 <div style={{
                   background: "#ffffff",
                   padding: "0.5rem",
                   borderRadius: "12px",
                   boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                   border: "1px solid #e2e8f0",
                   transition: "transform 0.2s ease",
                   cursor: "pointer"
                 }}
                 onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                 onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                 >
                   <img src={require("../assets/images/QR-CODE.jpeg")} alt="QR" style={{ width: 90, height: 90, borderRadius: "6px", display: "block" }} />
                 </div>
                 <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.6rem" }}>
                   <span style={{ fontSize: "0.85rem", color: "#64748b", fontWeight: "500", textAlign: "left" }}>Scan QR code or download directly:</span>
                   <a href="https://play.google.com/store/apps/details?id=com.trustapp"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "linear-gradient(135deg, #1e293b 0%, #2873f0 100%)",
                        color: "#ffffff",
                        padding: "10px 18px",
                        borderRadius: "12px",
                        fontSize: "0.88rem",
                        fontWeight: "600",
                        textDecoration: "none",
                        boxShadow: "0 4px 12px rgba(40, 115, 240, 0.2)",
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.boxShadow = "0 6px 16px rgba(40, 115, 240, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(40, 115, 240, 0.2)";
                      }}
                   >
                     <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                       <path d="M3,5.27V18.73L16.55,12L3,5.27M17.87,11.33L19.5,12.16L17.87,13L17.87,11.33M3,3.41L17.87,10.66L19.5,11.5L17.87,12.34L3,19.59V3.41Z" />
                     </svg>
                     Get it on Google Play
                   </a>
                 </div>
               </div>

               <div style={{ marginTop: "0.5rem", fontSize: "0.85rem", color: "#666", textAlign: "left", lineHeight: "1.6" }}>
                 <p style={{ marginBottom: "1.25rem", fontWeight: "700", color: "#1e293b", fontSize: "0.95rem", display: "flex", alignItems: "center", gap: "6px" }}>
                   <span>📱</span>
                   <span style={{ background: "linear-gradient(135deg, #2873f0, #1e293b)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
                     How to get started:
                   </span>
                 </p>
                 
                 <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
                   {/* Step 1 */}
                   <div className="step-item" style={{
                     display: "flex",
                     gap: "12px",
                     padding: "0.75rem 1rem",
                     borderRadius: "12px",
                     background: "linear-gradient(135deg, rgba(40, 115, 240, 0.08), rgba(30, 41, 59, 0.02))",
                     borderLeft: "4px solid #2873f0",
                     boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                   }}>
                     <span style={{
                       flexShrink: 0,
                       background: "linear-gradient(135deg, #2873f0, #1e40af)",
                       color: "white",
                       borderRadius: "50%",
                       width: "22px",
                       height: "22px",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       fontSize: "0.75rem",
                       fontWeight: "bold",
                       marginTop: "2px"
                     }}>1</span>
                     <div style={{ fontSize: "0.85rem", color: "#475569" }}>
                       <strong style={{ color: "#1e3a8a" }}>Download Trust App:</strong> Scan QR code or click <a className="playstore-link" href="https://play.google.com/store/apps/details?id=com.trustapp" target="_blank" rel="noopener noreferrer">here</a>
                     </div>
                   </div>

                   {/* Step 2 */}
                   <div className="step-item" style={{
                     display: "flex",
                     gap: "12px",
                     padding: "0.75rem 1rem",
                     borderRadius: "12px",
                     background: "linear-gradient(135deg, rgba(255, 193, 7, 0.08), rgba(255, 193, 7, 0.02))",
                     borderLeft: "4px solid #ffc107",
                     boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                   }}>
                     <span style={{
                       flexShrink: 0,
                       background: "linear-gradient(135deg, #ffc107, #d97706)",
                       color: "white",
                       borderRadius: "50%",
                       width: "22px",
                       height: "22px",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       fontSize: "0.75rem",
                       fontWeight: "bold",
                       marginTop: "2px"
                     }}>2</span>
                     <div style={{ fontSize: "0.85rem", color: "#475569" }}>
                       <strong style={{ color: "#b45309" }}>For Basic Use:</strong> Install the app - if you simply want to contact service or view job list, no profile creation needed
                     </div>
                   </div>

                   {/* Step 3 */}
                   <div className="step-item" style={{
                     display: "flex",
                     gap: "12px",
                     padding: "0.75rem 1rem",
                     borderRadius: "12px",
                     background: "linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(99, 102, 241, 0.02))",
                     borderLeft: "4px solid #6366f1",
                     boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                   }}>
                     <span style={{
                       flexShrink: 0,
                       background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                       color: "white",
                       borderRadius: "50%",
                       width: "22px",
                       height: "22px",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       fontSize: "0.75rem",
                       fontWeight: "bold",
                       marginTop: "2px"
                     }}>3</span>
                     <div style={{ fontSize: "0.85rem", color: "#475569" }}>
                       <strong style={{ color: "#4338ca" }}>For Service Providers:</strong> Create a profile in the app, then switch to Service Provider profile. The same profile works for both customer and provider roles
                     </div>
                   </div>

                   {/* Step 4 */}
                   <div className="step-item" style={{
                     display: "flex",
                     gap: "12px",
                     padding: "0.75rem 1rem",
                     borderRadius: "12px",
                     background: "linear-gradient(135deg, rgba(234, 60, 83, 0.08), rgba(234, 60, 83, 0.02))",
                     borderLeft: "4px solid #ea3c53",
                     boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                   }}>
                     <span style={{
                       flexShrink: 0,
                       background: "linear-gradient(135deg, #ea3c53, #b91c1c)",
                       color: "white",
                       borderRadius: "50%",
                       width: "22px",
                       height: "22px",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       fontSize: "0.75rem",
                       fontWeight: "bold",
                       marginTop: "2px"
                     }}>4</span>
                     <div style={{ fontSize: "0.85rem", color: "#475569" }}>
                       <strong style={{ color: "#b91c1c" }}>Learn More:</strong> Click <a className="youtube-link" href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE" target="_blank" rel="noopener noreferrer">here</a> to watch YouTube Video on How to add your business or profession
                     </div>
                   </div>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Login;